export default function PageHeader() {
  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div>
        <div className="flex items-center gap-2 mb-2">
          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-cream-100 text-ink-700 text-[10px] font-bold uppercase tracking-wider rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-ink-900"></span>
            Live Dashboard
          </span>
          <span className="text-xs text-ink-500">{today}</span>
        </div>
        <h1 className="font-display text-3xl md:text-4xl font-bold text-ink-900 leading-tight">
          Good morning, Elena
        </h1>
        <p className="text-sm text-ink-500 mt-1.5 max-w-xl">
          Here&apos;s what&apos;s moving today at Haulmark. You&apos;ve got 14 active jobs, 23 crew on the clock,
          and 4 new bookings waiting on confirmation.
        </p>
      </div>
    </div>
  );
}